import { useTranslation } from "react-i18next";

import { Group, Loader, Modal, Text } from "@mantine/core";

import { ZReportCard } from "@prostocheck/controls-web";

import { IZReportModalProps } from "./z-report-modal.models";

/**
 * Resolved from `reports` (the register page's currently-loaded Z-reports)
 * rather than fetched on its own — see `z-report-modal.models.ts`. A number
 * opened from outside the loaded filter range shows as not found rather than
 * guessing a wider one to search.
 */
export const ZReportModal = ({
  fiscalNumber,
  reports,
  isLoading,
  onClose,
}: IZReportModalProps) => {
  const { t } = useTranslation();
  const report = reports.find(
    candidate => candidate.fiscalNumber === fiscalNumber,
  );

  return (
    <Modal
      opened={Boolean(fiscalNumber)}
      onClose={onClose}
      size="lg"
      title={t("register.zReportModalTitle")}
      closeButtonProps={{ "aria-label": t("common:close") }}
    >
      {isLoading ? (
        <Group gap="sm" role="status">
          <Loader size="sm" />
          <Text size="sm" c="dimmed">
            {t("async.loading")}
          </Text>
        </Group>
      ) : report ? (
        <ZReportCard report={report} isExpanded />
      ) : (
        <Text size="sm" c="dimmed">
          {t("register.zReportNotInRange")}
        </Text>
      )}
    </Modal>
  );
};
